import { render, staticRenderFns } from "./ClaimWorkflowViewUserGroups.vue?vue&type=template&id=2dd762fd&scoped=true"
import script from "./ClaimWorkflowViewUserGroups.vue?vue&type=script&lang=js"
export * from "./ClaimWorkflowViewUserGroups.vue?vue&type=script&lang=js"
import style0 from "./ClaimWorkflowViewUserGroups.vue?vue&type=style&index=0&id=2dd762fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd762fd",
  null
  
)

export default component.exports